// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3jhtA","row":"Card_row__1WXu6","mainElement":"Card_mainElement__25P4R","element":"Card_element__1KDie","rows":"Card_rows__E2Knl"};